import React from 'react';
import PropTypes from 'prop-types';
import { WIZARD_STEP } from 'constants/wizardConstants';
import TabDepartment from 'components/WizardContents/Department/TabDepartment';
import TabJobTitle from 'components/WizardContents/JobTitle/TabJobTitle';
import TabHome from 'components/WizardContents/Home/TabHome';
import TabGnbMenu from 'components/WizardContents/GnbMenu/TabGnbMenu';
import TabBoard from 'components/WizardContents/Board/TabBoard';
import TabAnniversary from 'components/WizardContents/Anniversary/TabAnniversary';

export const TapContents = ({ step }) => {
  let selectedContent = '';
  switch (step) {
    case WIZARD_STEP.SETUP_JOBTITLE:
      selectedContent = <TabJobTitle />;
      break;
    case WIZARD_STEP.SETUP_DEPARTMENT:
      selectedContent = <TabDepartment />;
      break;
    case WIZARD_STEP.SETUP_HOME:
      selectedContent = <TabHome />;
      break;
    case WIZARD_STEP.SETUP_GNB_MENU:
      selectedContent = <TabGnbMenu />;
      break;
    case WIZARD_STEP.SETUP_BOARD:
      selectedContent = <TabBoard />;
      break;
    case WIZARD_STEP.SETUP_ANNIVERSARY:
      selectedContent = <TabAnniversary />;
      break;
    default:
      break;
  }
  return <div className="left">{selectedContent}</div>;
};
TapContents.propTypes = { step: PropTypes.number.isRequired };
TapContents.defaultProps = {};
export default TapContents;
